module.exports = __webpack_public_path__ + "static/img/haiwai_02.b1b0468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callMe/haiwai_02.png
// module id = LsFI
// module chunks = 3